import { API_URL } from "config";
import { useAuthContext } from "hooks/useAuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function useData() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [studentProjects, setstudentProjects] = useState([]);

  const handleProjectClick = (item) => {
    navigate("/view-project", { state: { project: item } });
  };

  useEffect(() => {
    const fetchstudentProjects = async () => {
      if (!user?.email || !user?.token) return;

      try {
        const response = await fetch(
          `${API_URL}/projects/getprojectsbystudent/${user.email}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch projects");
        }

        // const data = await response.json();
        console.log("Fetched Projects:", response);

        // Ensure data is an array and correctly set in state
        setstudentProjects(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setstudentProjects([]); // Ensure the state is reset on error
      }
    };

    fetchstudentProjects();
  }, [user]); // Depend only on specific fields

  return {
    columns: [
      { Header: "Title", accessor: "title", align: "center" },
      { Header: "Description", accessor: "description", align: "center" },
      { Header: "Last Updated", accessor: "lastupdated", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows:
      studentProjects.length > 0
        ? studentProjects.map((project) => ({
            key: project._id,
            title: project.projectTitle || "Untitled",
            description:
              project.projectDescription?.replace(/,\s*$/, "") ||
              "No description",
            lastupdated: project.updatedAt
              ? new Date(project.updatedAt).toLocaleDateString()
              : "Unknown",
            action: (
              <button
                onClick={() => handleProjectClick(project)}
                style={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "4px",
                }}
              >
                View
              </button>
            ),
          }))
        : [
            {
              title: "No projects yet",
              description: "-",
              lastupdated: "-",
              action: "-",
            },
          ],
  };
}
